// extracted by mini-css-extract-plugin
module.exports = {"StatusInfoPanel":"StatusInfoPanel_StatusInfoPanel__3ONxQ","col":"StatusInfoPanel_col__1yVz8"};